const sortOrderElement = document.getElementById('sort-order');
if (sortOrderElement) {
    sortOrderElement.addEventListener('change', function() {
        const currentUrl = new URL(window.location.href);
        
        // Remove any existing page parameter from the URL
        const path = currentUrl.pathname.replace(/\/page\/\d+/, '');
        
        // Set the new order
        currentUrl.pathname = path;
        currentUrl.searchParams.set('order', this.value);
        
        // Navigate to the modified URL
        window.location.href = currentUrl.toString();
    });
}